<template>
  <div class="container">

    <div class="logo">
      <a href="http://scimence.cn">
        <img src="../assets/logo.png">
      </a>
    </div>

    <div class = "menus"> 
      <ul>

        <li v-for="menu in menus">  
          <router-link v-bind:to="{ path: menu.path}" active-class="select">{{menu.tittle}}</router-link>
        </li>

      </ul>
    </div>

    <div class="search">
      <SearchIteam @Search="SearchSoft" v-bind:buttonName="'搜索软件'"></SearchIteam>
    </div>
    
  </div>
</template>

<script>
import SearchIteam from './control/SearchIteam.vue'
export default {
  name: 'PannelHeader',
  components: { SearchIteam },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      menus:
      [
        {tittle: "首页", path:"home"},
        {tittle: "软件详情", path:"soft?id=easyicon"},
        {tittle: "留言", path:"message"}
      ],

    }
  },
  methods: {
    // menuClick(path){
    //   menus.forEach(element => {
    //     element.tittle = "选中";
    //     if(element.path == path) element.selected = true;
    //     else element.selected = false;
    //   });
    // }

    SearchSoft(content)
    {
      if(content === '' ) content = '*';
      // console.log("SearchSoft已经调用！");

      // this.$router.push({ path: '/home', query: { key: content, list: "true" }});
      this.$router.push({ path: '/home', query: { key: content, list: "true" }}, this.Complate, this.Abort);
    }, 
    Complate(){
      // console.log("Complate已经调用！");
      location.reload();
    },
    Abort(){
      // console.log("Abort已经调用！");
      location.reload();
    },
  }
}
</script>

<style scoped>

.container {
  width: 100%;
  height: 48px;
  line-height: 48px;

  background-color: white;
  box-shadow: 0 0 5px 0px rgb(126, 125, 125);
  overflow:unset;
}

.logo {
  float:left;
  max-width: 80px;
  height: 100%;

  padding-left: 24px;
}

.logo img {
  display: block;
  width: 80px;
  min-width: 80px;
  height: 44px;
  /* margin-top: calc((48px - 44px)/ 2); */
}

.menus {
  float: left;
  padding-left: 48px;

  /* float:right; */
  /* padding-right: 48px; */
}

.menus ul 
{
  list-style-type:none;
  margin: 0px;
  padding: 0px;
}

.menus li 
{
  float:left;
  border-right: 1px solid white;
  height: 46px;
  margin-top: 1px;
}

.menus a:link,a:visited
{
  display:block;
  font-weight:bold;
  color:#222222;
  width:100px;
  height: 100%;
  text-align:center;
  margin: 0px;
  text-decoration:none;
  /* text-transform:uppercase; */
}

.menus a:active
{
  color:red;
}
.menus a:hover
{
  background-color: #F6F6F6;
}

.select{
  background-color: #ebebeb;
}

.search
{
  float:left;
  line-height: 44px;
  /* margin:5px; */
  margin-top: 9px;
}


</style>


// WEBPACK FOOTER //
// src/components/PannelHeader.vue